import { ROLES, SCOPE } from 'js/config/consts';

export const PERMISSIONS: Record<keyof typeof ROLES, SCOPE[]> = {
  FREE: [SCOPE.createPreviewLink, SCOPE.playbackPremiumContentWithoutWatermarks, SCOPE.useAiGenerations],
  PRO: [
    SCOPE.searchNounProject,
    SCOPE.addCustomFont,
    SCOPE.create10mVideo,
    SCOPE.create15mVideo,
    SCOPE.createPreviewLink,
    SCOPE.usePremiumContent,
    SCOPE.downloadPremiumContent,
    SCOPE.playbackPremiumContentWithoutWatermarks,
    SCOPE.useAiGenerations,
    SCOPE.setDefaultSettings,
    SCOPE.migrateLegacyProject
  ],
  PLUS: [
    SCOPE.searchNounProject,
    SCOPE.addCustomFont,
    SCOPE.create10mVideo,
    SCOPE.create15mVideo,
    SCOPE.createPreviewLink,
    SCOPE.usePremiumContent,
    SCOPE.downloadPremiumContent,
    SCOPE.playbackPremiumContentWithoutWatermarks,
    SCOPE.useAiGenerations,
    SCOPE.setDefaultSettings,
    SCOPE.migrateLegacyProject
  ],
  EDU: [
    SCOPE.searchNounProject,
    SCOPE.addCustomFont,
    SCOPE.create10mVideo,
    SCOPE.create15mVideo,
    SCOPE.createPreviewLink,
    SCOPE.usePremiumContent,
    SCOPE.downloadPremiumContent,
    SCOPE.playbackPremiumContentWithoutWatermarks,
    SCOPE.migrateLegacyProject
  ],
  LITE: [SCOPE.downloadPremiumContent, SCOPE.useAiGenerations, SCOPE.migrateLegacyProject],
  CORE: [
    SCOPE.searchNounProject,
    SCOPE.create10mVideo,
    SCOPE.createPreviewLink,
    SCOPE.usePremiumContent,
    SCOPE.downloadPremiumContent,
    SCOPE.playbackPremiumContentWithoutWatermarks,
    SCOPE.useAiGenerations,
    SCOPE.setDefaultSettings,
    SCOPE.migrateLegacyProject
  ],
  MAX: [
    SCOPE.searchNounProject,
    SCOPE.addCustomFont,
    SCOPE.create10mVideo,
    SCOPE.create15mVideo,
    SCOPE.create20mVideo,
    SCOPE.createPreviewLink,
    SCOPE.usePremiumContent,
    SCOPE.downloadPremiumContent,
    SCOPE.playbackPremiumContentWithoutWatermarks,
    SCOPE.useAiGenerations,
    SCOPE.setDefaultSettings,
    SCOPE.useBrandKit,
    SCOPE.migrateLegacyProject
  ]
};
